import React from 'react';
import { makeStyles } from '@material-ui/core';
import Typography from '../../overrides/Typography';
import { useFeatureFlags } from '../../../utils/useFeatureFlags';
import {
  HOME_ANNOUNCEMENT_BANNER_TITLE,
  HOME_ANNOUNCEMENT_BANNER_BODY_1_PREFIX,
  HOME_ANNOUNCEMENT_BANNER_BODY_1_DATE,
  HOME_ANNOUNCEMENT_BANNER_BODY_1_MIDDLE,
  HOME_ANNOUNCEMENT_BANNER_BODY_1_END_DATE,
  HOME_ANNOUNCEMENT_BANNER_BODY_2,
  HOME_ANNOUNCEMENT_BANNER_ENTERTAINMENT_LABEL,
} from '../../../assets/copy';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: '#D9EBED',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '32px 24px',
    gap: 24,
    boxSizing: 'border-box',
    [theme.breakpoints.up('md')]: {
      padding: '32px 0',
      margin: `0 ${theme.spacing(5)}`,
    },
    [theme.breakpoints.up('xxl')]: {
      maxWidth: theme.breakpoints.values.xxl,
      margin: '0 auto',
    },
  },
  textGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 16,
  },
  heading: {
    fontSize: 18,
    fontWeight: 600,
    color: '#14110D',
    opacity: 0.9,
    lineHeight: '28px',
    [theme.breakpoints.up('md')]: {
      fontSize: 20,
      lineHeight: '150%',
    },
  },
  bodyGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 12,
  },
  body: {
    fontSize: 14,
    color: '#14110D',
    opacity: 0.9,
    lineHeight: '20px',
    '& strong': {
      fontWeight: 600,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
      lineHeight: '150%',
    },
  },
  link: {
    fontWeight: 600,
    color: '#14110D',
    textDecoration: 'underline',
    '&:hover': {
      opacity: 0.7,
    },
  },
}));

const AnnouncementBanner = () => {
  const classes = useStyles();
  const { sunsetMessageDisplayFlagIsEnabled } = useFeatureFlags();

  if (!sunsetMessageDisplayFlagIsEnabled) return null;

  return (
    <section className={classes.root} data-cy="announcement-banner">
      <div className={classes.content}>
        <div className={classes.textGroup}>
          <Typography variant="medium2Semibold" component="h2" className={classes.heading}>
            {HOME_ANNOUNCEMENT_BANNER_TITLE}
          </Typography>
          <div className={classes.bodyGroup}>
            <Typography variant="medium1Normal" component="p" className={classes.body}>
              {HOME_ANNOUNCEMENT_BANNER_BODY_1_PREFIX}
              <strong>{HOME_ANNOUNCEMENT_BANNER_BODY_1_DATE}</strong>
              {HOME_ANNOUNCEMENT_BANNER_BODY_1_MIDDLE}
              <strong>{HOME_ANNOUNCEMENT_BANNER_BODY_1_END_DATE}</strong>.
            </Typography>
            <Typography variant="medium1Normal" component="p" className={classes.body}>
              {HOME_ANNOUNCEMENT_BANNER_BODY_2.split(HOME_ANNOUNCEMENT_BANNER_ENTERTAINMENT_LABEL)[0]}
              <a
                href="https://entertainment.capitalone.com/exclusive-events#dining"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
                data-cy="announcement-banner-link"
              >
                {HOME_ANNOUNCEMENT_BANNER_ENTERTAINMENT_LABEL}
              </a>
              {HOME_ANNOUNCEMENT_BANNER_BODY_2.split(HOME_ANNOUNCEMENT_BANNER_ENTERTAINMENT_LABEL)[1]}
            </Typography>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnnouncementBanner;
